/* Klaviyo · «Added to Cart» (29-sep-2026)
   Hasta hoy Klaviyo no sabía cuándo alguien añadía algo al carrito (0 eventos): sin eso no hay flow
   de carrito abandonado. Este tema añade por muchos caminos (global.js, landings, quiz, packs,
   lookbook, formularios normales), y varios scripts de terceros envuelven window.fetch, así que no
   tocamos fetch: miramos las peticiones ya hechas (PerformanceObserver) y, si alguna fue a
   /cart/add y salió bien, leemos /cart.js y mandamos a Klaviyo el evento con sus nombres estándar.
   Los formularios que recargan la página se apuntan al enviar y se cuentan al llegar.
   Klaviyo solo lo guarda si ya sabe quién es la persona. Todo en try/catch: si algo falla aquí,
   el carrito sigue funcionando igual. */
(function () {
  'use strict';
  var RE = /\/cart\/add(\.js)?$/;
  var FLAG = 'fhKlAdd';
  var espera = null;

  function permitido() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() !== false;
    } catch (e) {}
    return true;
  }
  function abs(u) { try { return u ? new URL(u, location.origin).href : ''; } catch (e) { return u || ''; } }
  function eur(c) { return Math.round(+c || 0) / 100; }
  function txt(c) { return (Math.round(+c || 0) / 100).toFixed(2).replace('.', ',') + ' €'; }   // «16,88 €» para el email

  function enviar(props) {
    try {
      var k = window.klaviyo;
      if (k && typeof k.track === 'function') { var r = k.track('Added to Cart', props); if (r && r.catch) r.catch(function () {}); }
      else (window._learnq = window._learnq || []).push(['track', 'Added to Cart', props]);
    } catch (e) {}
  }

  // Shopify pone lo último añadido el primero en /cart.js; si sabemos la variante, la buscamos.
  function registrar(variante) {
    if (!permitido()) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        var a = cart.items[0];
        if (variante) cart.items.forEach(function (i) { if (String(i.variant_id) === String(variante)) a = i; });
        enviar({
          $value: eur(cart.total_price),
          ValueText: txt(cart.total_price),
          ProductIDs: cart.items.map(function (i) { return String(i.product_id); }),
          AddedItemProductName: a.product_title,
          AddedItemProductID: String(a.product_id),
          AddedItemVariantID: String(a.variant_id),
          AddedItemSKU: a.sku || '',
          AddedItemImageURL: abs(a.image),
          AddedItemURL: abs(a.url),
          AddedItemPrice: eur(a.final_price),
          AddedItemQuantity: a.quantity,
          ItemNames: cart.items.map(function (i) { return i.product_title; }),
          ItemCount: cart.item_count,
          // Lleva algo con suscripción (el kit): el email de carrito promete palo santo y envío gratis solo entonces.
          Suscripcion: cart.items.some(function (i) { return !!i.selling_plan_allocation; }),
          // Rehace este carrito en cualquier dispositivo (permalink de Shopify) y lleva al pago.
          CheckoutURL: location.origin + '/cart/' + cart.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(','),
          CartURL: location.origin + '/cart',
          Items: cart.items.map(function (i) {
            return {
              ProductID: String(i.product_id), VariantID: String(i.variant_id), SKU: i.sku || '',
              ProductName: i.product_title, VariantName: i.variant_title || '',
              Quantity: i.quantity, ItemPrice: eur(i.final_price), RowTotal: eur(i.final_line_price),
              ItemPriceText: txt(i.final_price), RowTotalText: txt(i.final_line_price),
              ProductURL: abs(i.url), ImageURL: abs(i.image)
            };
          })
        });
      })
      .catch(function () {});
  }

  // 1) Peticiones AJAX (fetch o XHR) a /cart/add: una sola llamada aunque un pack añada varias seguidas.
  try {
    if (window.PerformanceObserver) {
      new PerformanceObserver(function (lista) {
        try {
          lista.getEntries().forEach(function (e) {
            if (e.initiatorType !== 'fetch' && e.initiatorType !== 'xmlhttprequest') return;
            var u; try { u = new URL(e.name); } catch (x) { return; }
            if (u.origin !== location.origin || !RE.test(u.pathname)) return;
            if (typeof e.responseStatus === 'number' && e.responseStatus > 0 && (e.responseStatus < 200 || e.responseStatus >= 300)) return;
            clearTimeout(espera);
            espera = setTimeout(function () { registrar(null); }, 800);
          });
        } catch (x) {}
      }).observe({ type: 'resource', buffered: false });
    }
  } catch (e) {}

  // 2) Formularios normales (recargan la página): apuntamos el intento y lo contamos al llegar.
  try {
    document.addEventListener('submit', function (ev) {
      try {
        var form = ev.target, act = form && form.getAttribute && form.getAttribute('action');
        if (!act) return;
        var p; try { p = new URL(act, location.origin).pathname; } catch (x) { return; }
        if (!RE.test(p)) return;
        var id = form.querySelector('[name="id"]');
        sessionStorage.setItem(FLAG, JSON.stringify({ v: id ? id.value : '', t: Date.now() }));
        // Si otro script lo hizo por AJAX (preventDefault), ya lo cuenta el paso 1.
        setTimeout(function () { if (ev.defaultPrevented) try { sessionStorage.removeItem(FLAG); } catch (x) {} }, 0);
      } catch (x) {}
    }, false);
    var m = sessionStorage.getItem(FLAG);
    if (m) {
      sessionStorage.removeItem(FLAG);
      m = JSON.parse(m);
      if (m && Date.now() - m.t < 60000) registrar(m.v);
    }
  } catch (e) {}
})();
